export function reportPath(route: string | null | undefined, reportKey: string): string {
  return route ?? `/reports/${reportKey}`;
}
